import { h } from 'preact'
import { Parti } from '../../../../domain'

type Props = {
  sisteParti: Parti
  nesteParti: Parti
}

export function Safe(props: Props) {
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 375 113">
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html: `
  .st0{fill:#26292A;}
  .st1{font-family:'LFT Etica'; font-weight: 700}
  .st2{font-size:22px;}
  .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#A5CD39;}
  .st4{opacity:5.000000e-02;fill-rule:evenodd;clip-rule:evenodd;}
  .st5{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:3.1093;stroke-linejoin:round;}
  .st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
  .st7{fill-rule:evenodd;clip-rule:evenodd;fill:#00B8F1;}`
        }}
      ></style>
      <g>
        <text
          transform="matrix(1 0 0 1 278 111)"
          class="st0 st1 st2"
          style={{ textAnchor: 'middle' }}
        >
          {props.sisteParti.kortNavn}
        </text>
        <circle class="st3" cx="278" cy="41" r="39" style={{ fill: props.sisteParti.farge }} />
        <path
          class="st4"
          d="M240.5,30.3c-1,3.6-1.6,7.4-1.5,11.3c0.3,21.3,17.4,38.2,38.9,38.4
		c6.7,0.1,13-1.7,18.6-4.7c-3.6,0.9-7.3,1.4-11.1,1.4c-24.7,0-44.9-19.8-44.9-44.2C240.5,31.8,240.5,31,240.5,30.3"
        />
        <path
          class="st5"
          d="M295.4,46c0,9.5-7.6,17.1-17.1,17.1c-9.5,0-17.1-7.6-17.1-17.1H295.4L295.4,46z"
        />
        <circle class="st6" cx="269" cy="26.9" r="4" />
        <circle class="st6" cx="287.3" cy="26.9" r="4" />
        <text
          transform="matrix(1 0 0 1 106.4998 111)"
          class="st0 st1 st2"
          style={{ textAnchor: 'middle' }}
        >
          {props.nesteParti.kortNavn}
        </text>
        <path
          class="st7"
          d="M145,34.2c0,0-30.3,5.4-38.2,6.9c-10.8,2,32,22.1,32,22.1c-7,10.2-18.7,16.9-32,16.9
		C85.4,80,68,62.5,68,41S85.4,2,106.8,2C125.9,2,141.8,15.9,145,34.2z"
          style={{ fill: props.nesteParti.farge }}
        />
        <path
          class="st4"
          d="M69.5,30.3c-1,3.6-1.6,7.4-1.5,11.3C68.3,62.9,85.4,80,106.9,80c6.7,0,12.3-1.6,18-4.5
		c-3.6,0.9-6.7,1.3-10.6,1.3c-24.7,0-44.9-19.8-44.9-44.2C69.5,31.8,69.5,31,69.5,30.3"
        />
        <circle class="st6" cx="116" cy="21" r="4" />
      </g>
    </svg>
  )
}
